module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/pride_day-52e0b6292574acb2b473d0f3dcf7a68b.svg";